/**
 * Represents a Modal.
 */
class Modal {
	/**
	 * Creates an instance of Modal.
	 *
	 * @param {HTMLElement} modalTrigger - The trigger element for the modal.
	 */
	constructor( modalTrigger ) {
		this.modalTrigger = modalTrigger;
		this.modalId = this.modalTrigger.dataset.formId;
		this.modalTitle = this.modalTrigger.dataset.modalTitle;
		this.modal = document.getElementById( `form-modal-${ this.modalId }` );
		this.modalHeading = this.modal.querySelector( '.rt-modal-heading' );

		if ( ! this.modal ) {
			return;
		}

		this.closeModalTrigger = this.modal.querySelector( '.close-modal' );

		this.openModal = this.openModal.bind( this );
		this.closeModal = this.closeModal.bind( this );

		this.closeModalTrigger.addEventListener( 'click', this.closeModal );
		this.modalTrigger.addEventListener( 'click', this.openModal );

		// Close modal on escape key press.
		document.addEventListener( 'keydown', ( event ) => {
			if ( event.key === 'Escape' ) {
				this.closeModal();
			}
		} );
	}

	/**
	 * Opens the modal.
	 *
	 * @param {Event} event - The event object.
	 */
	openModal( event ) {
		event.preventDefault();

		// Set the modal title.
		this.gformTitle = this.modal.querySelector( '.gform_title' );

		if ( this.gformTitle ) {
			this.gformTitle.innerText = this.modalTitle ? this.modalTitle : this.modalHeading.innerText;
		}

		document.body.classList.add( 'modal-open' );
		this.modal.classList.add( 'is-open' );
	}

	/**
	 * Closes the modal.
	 */
	closeModal() {
		this.modal.classList.remove( 'is-open' );
		document.body.classList.remove( 'modal-open' );
	}
}

/**
 * Initializes all modals on the page.
 */
function initModals() {
	const modalsButtons = document.querySelectorAll( '.button-with-form' );
	modalsButtons?.forEach( ( modalTrigger ) => {
		new Modal( modalTrigger );
	} );
}

// Call the initModals function when the DOM content is loaded.
document.addEventListener( 'DOMContentLoaded', initModals, { once: true } );
